module.exports = __webpack_public_path__ + "pcstatic/img/carsilogo.35bb7eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/carsilogo.png
// module id = 3Ldi
// module chunks = 28